import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, Switch } from 'react-router-dom';

import Trends from "../containers/Trends";
import AuthorizedUser from "../utils/AuthorizedUser";
import AuthorizedUserContext from "../utils/AuthorizedUserContext";

function TrendsRouter(props) {
	const authenticatedUser = useContext(AuthorizedUserContext);
	let {updateHeader, resetHeader, showSnackbar, setBannerClassName,
			setFullScreenClassName, hasNudgeBanner, history, previousLocation} = props,
		routes = TrendsRouter.getRoutes();

	return (
		<Switch>
			<Redirect
				exact
				from={routes[0]}
				to={routes[1]} />
			<Route
				path={[routes[1],routes[4]]}
				render={renderProps =>
					<Trends
						{...renderProps}
						history={history}
						previousLocation={previousLocation}
						updateHeader={updateHeader}
						resetHeader={resetHeader}
						showSnackbar={showSnackbar}
						hasNudgeBanner={hasNudgeBanner}
						setBannerClassName={setBannerClassName}
						setFullScreenClassName={setFullScreenClassName}	/>
				} />

			{AuthorizedUser.hasGmailSentiment(authenticatedUser) || AuthorizedUser.hasExchangeSentiment(authenticatedUser) ?
				<Route
					path={routes[2]}
					render={renderProps =>
						<Trends
							{...renderProps}
							updateHeader={updateHeader}
							resetHeader={resetHeader}
							showSnackbar={showSnackbar}
							hasNudgeBanner={hasNudgeBanner}
							setBannerClassName={setBannerClassName}
							setFullScreenClassName={setFullScreenClassName} />
					} />
				:
				<Redirect
					from={routes[2]}
					to="/no-access" />
			}

			{AuthorizedUser.isK12(authenticatedUser) ?
				<Route
					path={routes[3]}
					render={renderProps =>
						<Trends
							{...renderProps}
							updateHeader={updateHeader}
							resetHeader={resetHeader}
							showSnackbar={showSnackbar}
							hasNudgeBanner={hasNudgeBanner}
							setBannerClassName={setBannerClassName}
							setFullScreenClassName={setFullScreenClassName} />
					} />
				:
				<Redirect
					from={routes[3]}
					to="/no-access" />
			}
		</Switch>
	);
}

TrendsRouter.getRoutes = () => {
	const routes = [
		"/trends",
		"/trends/topics",
		"/trends/student-sentiment",
		"/trends/national-student-sentiment",
		"/trends/topics/:topicId"
	];
	return routes;
};

TrendsRouter.propTypes = {
	history: PropTypes.object.isRequired,
	location: PropTypes.object.isRequired,
	previousLocation: PropTypes.object,
	updateHeader: PropTypes.func,
	resetHeader: PropTypes.func,
	showSnackbar: PropTypes.func,
	setBannerClassName: PropTypes.func,
	hasNudgeBanner: PropTypes.bool,
	setFullScreenClassName: PropTypes.func
};

export default TrendsRouter;